import { useTranslation } from "react-i18next";
import type { ProformaStatus } from "@/lib/types";
import { STATUS_CLASS, STATUS_LABEL_KEY } from "@/features/proformas/labels";

interface StatusProps {
  status: ProformaStatus;
  /** Override the visible label (defaults to the localized status name). */
  label?: string;
}

/**
 * The one and only status pill. Renders `.avds-status--<state>` — never build a
 * bespoke pill. The "living" states (review, inprogress) pulse via the CSS.
 */
export function Status({ status, label }: StatusProps) {
  const { t } = useTranslation();
  return (
    <span className={`avds-status avds-status--${STATUS_CLASS[status]}`}>
      <span className="avds-status__dot" />
      {label ?? t(STATUS_LABEL_KEY[status] as never)}
    </span>
  );
}
